import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {ServiceHttpService} from './services/services.http.service';
import {ServicesApprovalService} from './services/services-approval.service';
import {BDProjectsModule, BDSharedModule} from '@brother-apps/brother-dealerapp-shared-lib';
import {FormsModule} from '@angular/forms';
import {
    ModalAgreementNotConfirmedInfoComponent
} from './components/modal-agreement-not-confirmed-info/modal-agreement-not-confirmed-info.component';
import {
    ModalServicesDataProcessingAgreementComponent
} from './components/modal-services-data-processing-agreement/modal-services-data-processing-agreement.component';
import {
    ModalServicesDataProcessingAgreementNewComponent
} from './components/modal-services-data-processing-agreement-new/modal-services-data-processing-agreement-new.component';


@NgModule({
    imports: [
        CommonModule,
        BDProjectsModule,
        BDSharedModule,
        FormsModule,
    ],
    declarations: [
        ModalServicesDataProcessingAgreementComponent,
        ModalAgreementNotConfirmedInfoComponent,
        ModalServicesDataProcessingAgreementNewComponent
    ],
    exports: [
        ModalAgreementNotConfirmedInfoComponent
    ],
    providers: [
        ServiceHttpService,
        ServicesApprovalService,
    ]
})
export class ServiceModule {
}
